import { useEffect, useRef, useState } from "react";

/**
 * Subscribes to backend market websocket and returns the latest prices map.
 * Url pattern: wss://<host>/api/ws/market
 */
export default function useMarketSocket() {
  const [prices, setPrices] = useState({}); // { index_id: { current_price, change_24h, heat_score, ts } }
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);

  useEffect(() => {
    const sameOrigin = typeof window !== "undefined" ? window.location.origin : "";
    const envBackend = process.env.REACT_APP_BACKEND_URL || "";
    const backend = sameOrigin && sameOrigin.startsWith("https://") ? sameOrigin : envBackend;
    const wsUrl = backend.replace(/^http/, "ws") + "/api/ws/market";
    let alive = true;

    const connect = () => {
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;
      ws.onopen = () => { if (alive) setConnected(true); };
      ws.onclose = () => { if (alive) { setConnected(false); setTimeout(connect, 3000); } };
      ws.onerror = () => { try { ws.close(); } catch (e) { console.debug("[market-ws] close error", e); } };
      ws.onmessage = (evt) => {
        try {
          const payload = JSON.parse(evt.data);
          if (payload.type === "tick") {
            setPrices((prev) => {
              const next = { ...prev };
              for (const u of payload.updates) {
                next[u.index_id] = u;
              }
              return next;
            });
          }
        } catch (e) { console.debug("[market-ws] parse error", e); }
      };
    };

    connect();
    return () => {
      alive = false;
      try { wsRef.current && wsRef.current.close(); } catch (e) { console.debug("[market-ws] unmount close error", e); }
    };
  }, []);

  return { prices, connected };
}
